/*
使用例子
appFun(函数名字，传递的参数,function(data){
    data 为客户端返回的数据
})

或者没有传递参数的
appFun(函数名字，function(data){
    data 为客户端返回的数据
})

*/
(function () {
  let appid = 0;
  const native: any = {};
  const iosNeedMessageFun: any = [
    'buildRequest',
    'extractResponse',
    'getUid',
    'getTicket',
    'getArea',
    'getLanguage',
    'getDeviceId',
    'getDeviceIsSimulator',
    'getNative',
    'requestImageChooser',
    'httpRequest',
    'openChargePage',
    'downLoadFile',
    'sendGiftToSingleGift',
    'startSpecifyChat',
    'agentExport',
    'openToolbar',
    'shareRoom',
    'openGiftTab',
    'openGame',
    'onFirebaseEvent',
    'h5Log',
    'skipToHomeSpecifyPage',
  ];
  const iosGetMessageFun: any = {
    getTicket: 'ticket',
    getUid: 'uid',
    getDeviceId: 'deviceId',
    getArea: 'area',
    getLanguage: 'lang',
    getNative: 'native',
    requestImageChooser: 'requestImageChooser',
    httpRequest: 'httpRequest',
    getDeviceIsSimulator: 'isSimulator',
    downLoadFile: 'downLoadFile',
    sendGiftToSingleGift: 'sendGiftToSingleGift',
    startSpecifyChat: 'startSpecifyChat',
    agentExport: 'agentExport',
    openToolbar: 'openToolbar',
    shareRoom: 'shareRoom',
    openGiftTab: 'openGiftTab',
    openGame: 'openGame',
    onFirebaseEvent: 'onFirebaseEvent',
    h5Log: 'h5Log',
    skipToHomeSpecifyPage: 'skipToHomeSpecifyPage',
  };
  const androidNeedMessageFun: any = [
    'showShareButton',
    'getNative',
    'httpRequest',
    'getDeviceIsSimulator',
    'downLoadFile',
    'sendGiftToSingleGift',
    'startSpecifyChat',
    'agentExport',
    'openToolbar',
    'shareRoom',
    'openGiftTab',
    'openGame',
    'onFirebaseEvent',
    'h5Log',
    'skipToHomeSpecifyPage',
  ];
  const rnFun: any = {
    getNative: 'native',
  };
  const system = (function () {
    const sysJuc = {
      ios: /(iPhone|iPad|iPod|iOS)/i,
      android: /(Android)/i,
    };
    const nav = navigator.userAgent;
    return sysJuc.ios.test(nav) ? 'ios' : sysJuc.android.test(nav) ? 'android' : 'other';
  })();
  window.appSystem = system;
  function isFun(fun: any) {
    return Object.prototype.toString.call(fun) == '[object Function]';
  }
  function isJSONStr(str: any) {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str);
        if (typeof obj == 'object') {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  }
  window.shareInfo = function (data: any) {};

  window.appCallJs = function (data: any) {
    console.log('window.appCallJs ', data, native);
    data = isJSONStr(data) ? JSON.parse(data) : data;
    // console.log('data',data,data.id,data.data);
    native[data.id] && native[data.id](data.data);
    delete native[data.id];
  };
  window.getMessage = function (id: any, data: any) {
    // console.log('window.getMessage ',id,data,native);
    data = isJSONStr(data) ? JSON.parse(data) : data;
    native[id] && native[id](data);
    delete native[id];
  };
  window.appFun = function (e: any) {
    const arg = arguments;
    console.log('arguments', arguments);
    const funName = Array.prototype.shift.call(arg);
    let appObj: any = {};
    const callback = isFun(arg[0]) ? arg[0] : arg[1];
    isFun(arg[0]) ? (arg[0] = undefined) : '';
    try {
      if (system === 'ios') {
        // console.log("ios",funName,arg[0]);
        if (window.webkit.messageHandlers[funName]) {
          appObj = window.webkit.messageHandlers;
        } else {
          appObj = window.ReactNativeWebView;
        }
        // console.log("appObj",appObj);
        if (iosNeedMessageFun.indexOf(funName) > -1) {
          let key = appid;
          key = iosGetMessageFun[funName] || key;
          native[key] = function (data: any) {
            callback && callback(data);
          };
          if (arg[0] !== undefined) {
            var data = {
              id: key,
              data: {},
            };
            if (isJSONStr(arg[0])) {
              data.data = JSON.parse(arg[0]);
            } else {
              data.data = arg[0];
            }
            if (arg[0] == 'noParam') {
              data.data = {};
            }
            arg[0] = JSON.stringify(data);
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(JSON.stringify({ type: funName, data: arg[0] || null }));
            } else {
              if (rnFun[funName]) {
                //rn 独有方法
                return;
              }
              appObj[funName] && appObj[funName].postMessage(arg[0]);
            }
          } else {
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(JSON.stringify({ type: funName, data: arg[0] || null }));
            } else {
              if (rnFun[funName]) {
                return;
              }
              appObj[funName] && appObj[funName].postMessage(null);
            }
          }
          appid++;
        } else {
          if (arg[0] !== undefined) {
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(JSON.stringify({ type: funName, data: arg[0] || null }));
            } else {
              if (rnFun[funName]) {
                return;
              }
              appObj[funName] && appObj[funName].postMessage(arg[0]);
            }
          } else {
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(JSON.stringify({ type: funName, data: arg[0] || null }));
            } else {
              if (rnFun[funName]) {
                return;
              }
              appObj[funName] && appObj[funName].postMessage(null);
            }
          }
        }
      } else {
        appObj = window.androidJsObj;
        console.log('appObj', appObj);
        if (rnFun[funName]) {
          callback && callback(rnFun[funName]);
          return;
        }
        if (androidNeedMessageFun.indexOf(funName) > -1) {
          native[appid] = function (data: any) {
            callback && callback(data);
          };
          if (arg[0] !== undefined) {
            var data = {
              id: appid,
              data: {},
            };
            if (isJSONStr(arg[0])) {
              data.data = JSON.parse(arg[0]);
            } else {
              data.data = arg[0];
            }
            arg[0] = JSON.stringify(data);

            appObj[funName](arg[0]);
          } else {
            appObj[funName]();
          }
          appid++;
        } else {
          if (arg[0] !== undefined && arg[0] !== 'noParam') {
            callback ? callback(appObj[funName](arg[0])) : appObj[funName](arg[0]);
          } else {
            callback ? callback(appObj[funName]()) : appObj[funName]();
          }
        }
      }
    } catch (e) {
      console.log(e, '错误');
    }
  };
})();
